import {isArray, isEmpty, max} from "lodash";

export const filterList = (list, keyword) => {

    return list.filter(one => {
        const _keyword = String(keyword)?.trim()?.toLowerCase();
        const _internalId = one?.InternalId?.trim()?.toLowerCase();
        // const _barcode = one?.Barcode?.trim()?.toLowerCase();
        // const _barcode = one?.UPC?.trim()?.toLowerCase();
        const _name = one?.Name?.trim()?.toLowerCase();
        // const _hasToBuy = one._hasToBuy === true;

        if (isEmpty(_keyword)) return true;

        return _name.includes(_keyword) || _internalId.includes(_keyword) ;
    })
}

export const addMetaData = (list, shipping, receiving, pos) => {
    return list?.map(one => {
        const existShipping = shipping?.find(shi => shi?.ProductId === one?.id);
        const existReceiving = receiving?.find(shi => shi?.ItemId === one?.id);
        const existPo = pos?.find(shi => shi?.id === one?.id);

        return {
            ...one,
            shipped: existShipping?.Quantity || 0,
            received: existReceiving?.Quantity || 0,
            ContainerCode: existShipping?.ContainerCode,
            ActivityStatus: existShipping?.ActivityStatus,
            shipping: existShipping?.shipping || [],
            pos: existPo?.pos || [],
            totalQuantity: (shipping?.totalQuantity || 0) + (existPo?.totalQuantity || 0)
        }

    })
}

const groupItems = (list, idKey) => {
    let groups = []

    isArray(list) && list.forEach((e) => {
        let ex = {...e}

        let exist = groups.find(i => i[idKey] === ex[idKey])

        if (exist) {
            exist.Quantity += ex.Quantity;
            exist.Price = max([exist?.Price, ex?.Price])

        } else {
            groups.push(ex)
        }
    });

    return groups;
}

export const groupShipping = (shipping) => groupItems(shipping, 'ProductId');

export const groupReceiving = (receiving) => groupItems(receiving, 'ItemId');
